import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Download } from 'components/Icon';
import { Text } from 'components/library';

import * as S from './styled';

interface GuideProps {
    img?: string;
    link?: string;
    title: string;
    onDownload?: (name: string) => void;
}

const Guide: FC<GuideProps> = ({ title, img, link, onDownload }) => {
    const { t } = useTranslation();
    const translatedTitle = t(title);

    const handleDownloadClick = () => onDownload?.(translatedTitle);

    return (
        <S.Container>
            {img && <S.GuideImg as="img" alt="guide-img" src={img} />}
            <S.GuideTitleContainer>
                <Text center={!img} type="medium-text">
                    {translatedTitle}
                </Text>
            </S.GuideTitleContainer>
            {link && (
                <a href={link} target="_blank" rel="noopener noreferrer" onClick={handleDownloadClick}>
                    <Download />
                </a>
            )}
        </S.Container>
    );
};

export default Guide;
